const messages = {
  fr: {
    beginReservation: 'Début de réservation',
    lengthOfTime: 'Durée',
    weeks: 'semaine | semaines',
    More: 'Plus',
    contactUsDirectlyForLargerMoves:
      'Pour les déménagements plus grands avec des bureaux ou une bibliothèque, etc., veuillez prendre {0} directement avec nous.',
    Contact: 'contact',
    contact: 'contact',
    next: 'Continuer',

    monday: 'lundi',
    tuesday: 'mardi',
    wednesday: 'mercredi',
    thursday: 'jeudi',
    friday: 'vendredi',
    saturday: 'samedi',
    sunday: 'dimanche',

    '2 weeks': '2 semaines',
    '3 weeks': '3 semaines',
    '4 weeks': '4 semaines',
    '5 weeks': '5 semaines',
    '6 weeks': '6 semaines',
    '7 weeks': '7 semaines',
    '8 weeks': '8 semaines',

    pleaseSelectYourItems: 'Veuillez choisir vos articles',
    notSureCalculateYourNeeds: "Vous n'êtes pas sûr? {0}",
    calculateNeeds: 'Calculez ici votre besoin en quantité',
    youShouldRentXXBoxes: 'Vous devriez louer <span>{amount}</span> boîtes.',

    deliverBoxToHome: 'Faire livrer les caisses',
    pickUpBoxesYourself: 'Aller chercher les caisses',
    shippingAddress: 'Adresse de livraison',
    beforeMove: 'avant le déménagement',
    pickupAddress: "Adresse d'enlèvement",
    afterMove: 'après le déménagement',
    Address: 'Nom de la rue',
    zipCode: 'NPA',
    City: 'Ville',
    'Additional Information': 'Informations supplémentaires',
    sameDeliveryAddressBeforeAndAfterMoving:
      "L'adresse de livraison correspond à l'adresse de retrait après le déménagement",
    pleaseEnterYourAddress: 'Veuillez saisir votre adresse:',
    pleaseEnterYourZipCode: "S'il vous plait, entrez votre code postal:",

    yourPersonalData: 'Vos informations personnelles',
    Salutation: 'Titre',
    'First Name': 'Prénom',
    'Last Name': 'Nom de famille',
    Company: 'Société',
    'Email address': 'Adresse e-mail',
    Mobile: 'Téléphone portable',
    Notes: 'Notes',
    getYourDataFromSwisspass: 'Récupérez vos données SwissPass',
    swisspassID: 'Swiss Pass ID',
    'Load data': 'Charger les données',
    'Do you have voucher?': "Avez-vous un bon d'achat?",
    'Voucher Code': 'Code du bon',
    'Apply Voucher': "Appliquer le bon d'achat",
    'I accept the': "J'accepte les {0}",
    'Terms and Conditions': 'conditions générales',

    Summary: 'Résumé',
    'Reserve and go to payment': 'Vers la caisse',

    // Country Selector
    Switzerland: 'Suisse',
    Germany: 'Allemagne',
    Austria: 'Autriche',
    Liechtenstein: 'Liechtenstein',

    // STEP 4
    swissPassError: 'Il semble que quelque chose ne va pas. Veuillez réessayer plus tard.',
    Country: 'Pays',
    HERR: 'M',
    FRAU: 'Mme',
    '---': '---',
    fillInIfBusinessOrder: "A remplir s'il s'agit d'une commande professionnelle.",
    choose: 'sélectionner', // Button on map to select store
    'Remove data': 'Supprimer les données',

    // STEP 5
    'Contact Information': 'Coordonnées',
    'Delivery details': 'Adresse de livraison',
    'Your Products': 'Vos articles',
    billingAddress: 'Adresse pour la facturation',
    'Pickup place details': 'Détails du lieu de collecte',
    Date: 'Date',

    // bottom bar
    from: 'À partir de', // Price from
    for: 'Pour',
    article: '{amount} article | {amount} articles',

    // MAP
    'User Location': 'Votre lieu',

    // User needs calculator
    calculator: {
      numberOfRooms: 'Nombre de chambres',
      numberOfAdults: "Nombre d'adultes",
      numberOfYears: "Nombre d'années à cet endroit",
    },

    // Payment
    'Payment Form': 'Caisse',

    // Thank you page
    'Thank You!': 'Merci!',
    'Your reservation was successful.': 'Votre réservation est acceptée.',
    'Please check your email with the reservation details.':
      'Veuillez vérifier votre e-mail avec les détails de la réservation.',
    'Your reservation number is #{number}': 'Votre numéro de réservation est R#{number}.',
    'After changing any of this value your basket will be cleared.':
      "Après avoir modifié l'une de ces valeurs, votre panier sera vidé.",
    'Please confirm your location:': 'Veuillez confirmer votre position:',
  },
}

export default messages
